const COOKIE_NAME = 'smmart_consent'
const VERSION = 2
const MAX_AGE = 180 * 24 * 60 * 60
const CATEGORIES = ['analytics', 'advertising', 'external']

function choices(value) {
  return { analytics: value === true, advertising: value === true, external: value === true }
}

function cookieValue(document, name) {
  const prefix = name + '='
  const cookie = document.cookie.split(';').map(part => part.trim()).find(part => part.indexOf(prefix) === 0)
  return cookie ? cookie.slice(prefix.length) : null
}

function readPreferences(document, now) {
  const raw = cookieValue(document, COOKIE_NAME)
  if (raw !== null) {
    try {
      const saved = JSON.parse(decodeURIComponent(raw))
      if (saved.version === VERSION && typeof saved.savedAt === 'number' &&
          saved.savedAt <= now && now - saved.savedAt < MAX_AGE * 1000 &&
          CATEGORIES.every(category => typeof saved[category] === 'boolean')) {
        return saved
      }
    } catch (error) { /* Invalid or obsolete preferences never grant consent. */ }
    return null
  }
  // Old acceptance did not distinguish purposes. Only an old refusal is retained.
  return cookieValue(document, 'cookie_consent') === 'false' ? choices(false) : null
}

function savePreferences(document, location, value, now) {
  const saved = Object.assign({ version: VERSION, savedAt: now }, choices(false))
  CATEGORIES.forEach(category => { saved[category] = value[category] === true })
  document.cookie = COOKIE_NAME + '=' + encodeURIComponent(JSON.stringify(saved)) +
    '; Path=/; Max-Age=' + MAX_AGE + '; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : '')
  document.cookie = 'cookie_consent=; Path=/; Max-Age=0; SameSite=Lax'
  return saved
}

function googleConsent(value) {
  return {
    analytics_storage: value.analytics ? 'granted' : 'denied',
    ad_storage: value.advertising ? 'granted' : 'denied',
    ad_user_data: value.advertising ? 'granted' : 'denied',
    ad_personalization: value.advertising ? 'granted' : 'denied'
  }
}

// Only known, accessible tracking cookies are removed; session/CSRF cookies stay intact.
function clearTrackingCookies(document, location, value) {
  const patterns = []
  if (!value.analytics) patterns.push(/^_ga(?:_|$)/, /^_gid$/, /^_gat(?:_|$)/, /^_clck$/, /^_clsk$/)
  if (!value.advertising) patterns.push(/^_gcl_/, /^_gac_/, /^_fbp$/, /^_fbc$/)
  const domains = ['']
  const parts = location.hostname.split('.')
  while (parts.length > 1) {
    domains.push(parts.join('.'), '.' + parts.join('.'))
    parts.shift()
  }
  const paths = ['/']
  const segments = location.pathname.split('/').filter(Boolean)
  segments.forEach((segment, index) => {
    const path = '/' + segments.slice(0, index + 1).join('/')
    paths.push(path, path + '/')
  })
  document.cookie.split(';').forEach(part => {
    const name = part.trim().split('=')[0]
    if (!patterns.some(pattern => pattern.test(name))) return
    domains.forEach(domain => paths.forEach(path => {
      document.cookie = name + '=; Max-Age=0; Path=' + path +
        (domain ? '; Domain=' + domain : '') + '; SameSite=Lax' +
        (location.protocol === 'https:' ? '; Secure' : '')
    }))
  })
}

module.exports = { CATEGORIES, MAX_AGE, choices, readPreferences, savePreferences, googleConsent, clearTrackingCookies }
